import { useState } from 'react';
import { useFeed } from '../hooks/useFeed';
import { useAuth } from '../context/AuthContext';
import UploadModal from '../components/UploadModal';

const STORIES = [{ name:'Adaeze', flag:'🇳🇬' },{ name:'Wanjiru', flag:'🇰🇪' },{ name:'Kofi', flag:'🇬🇭' },{ name:'Aminata', flag:'🇸🇳' },{ name:'Thabo', flag:'🇿🇦' },{ name:'Tigist', flag:'🇪🇹' }];
const TABS = ['For You','Following','Music','Food','Fashion'];
const COLORS = ['#C94B30','#1D9E75','#534AB7','#BA7517','#085041','#3C3489'];
const getColor = s => COLORS[(s?.charCodeAt(0)||0) % COLORS.length];
const initials = n => (n||'U').split(' ').map(w=>w[0]).join('').slice(0,2).toUpperCase();
function timeAgo(ts) {
  if (!ts?.toDate) return '';
  try {
    const s = Math.floor((Date.now() - ts.toDate().getTime()) / 1000);
    if (s < 60) return 'just now';
    if (s < 3600) return Math.floor(s/60) + 'm ago';
    if (s < 86400) return Math.floor(s/3600) + 'h ago';
    return Math.floor(s/86400) + 'd ago';
  } catch { return ''; }
}

export default function FeedPage() {
  const { posts, loading, likePost } = useFeed();
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState(0);
  const [showUpload, setShowUpload] = useState(false);

  return (
    <div style={{ display:'flex', flexDirection:'column', flex:1, height:'100%', overflow:'hidden', background:'var(--night)' }}>
      <div style={{ padding:'16px 20px 12px', borderBottom:'1px solid var(--border)', background:'var(--earth)', display:'flex', alignItems:'center', justifyContent:'space-between', flexShrink:0 }}>
        <div>
          <h2 style={{ fontFamily:'Sora,sans-serif', fontSize:18, fontWeight:600, color:'var(--text)' }}>Umoja</h2>
          <p style={{ fontSize:12, color:'var(--muted)', marginTop:2 }}>Africa's platform 🌍</p>
        </div>
        <button onClick={() => setShowUpload(true)} style={{ padding:'8px 16px', borderRadius:30, background:'linear-gradient(135deg, var(--sunset), var(--flame))', color:'white', border:'none', fontSize:13, fontWeight:500, cursor:'pointer' }}>+ Post</button>
      </div>

      <div style={{ display:'flex', gap:12, padding:14, overflowX:'auto', flexShrink:0, borderBottom:'1px solid var(--border)' }}>
        <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:5, cursor:'pointer', flexShrink:0 }} onClick={() => setShowUpload(true)}>
          <div style={{ width:56, height:56, borderRadius:'50%', background:'var(--surface)', border:'1px dashed rgba(255,255,255,0.2)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22 }}>+</div>
          <span style={{ fontSize:10, color:'var(--muted)' }}>Your story</span>
        </div>
        {STORIES.map(s => (
          <div key={s.name} style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:5, cursor:'pointer', flexShrink:0 }}>
            <div style={{ width:56, height:56, borderRadius:'50%', background:'linear-gradient(135deg, var(--sunset), var(--flame))', padding:2, display:'flex', alignItems:'center', justifyContent:'center' }}>
              <div style={{ width:50, height:50, borderRadius:'50%', background:'var(--surface)', display:'flex', alignItems:'center', justifyContent:'center', fontSize:20, border:'2px solid var(--night)' }}>{s.flag}</div>
            </div>
            <span style={{ fontSize:10, color:'var(--muted)', maxWidth:56, textAlign:'center' }}>{s.name}</span>
          </div>
        ))}
      </div>

      <div style={{ display:'flex', borderBottom:'1px solid var(--border)', flexShrink:0 }}>
        {TABS.map((t,i) => (
          <button key={t} onClick={() => setActiveTab(i)} style={{ flex:1, padding:'10px 0', textAlign:'center', fontSize:13, color: activeTab===i ? 'var(--sunset)' : 'var(--muted)', cursor:'pointer', border:'none', background:'transparent', borderBottom: activeTab===i ? '2px solid var(--sunset)' : '2px solid transparent', fontWeight: activeTab===i ? 500 : 400 }}>{t}</button>
        ))}
      </div>

      <div style={{ flex:1, overflowY:'auto', padding:12, display:'flex', flexDirection:'column', gap:12 }}>
        {loading && <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:200 }}><div style={{ width:24, height:24, borderRadius:'50%', border:'2px solid var(--border)', borderTopColor:'var(--sunset)', animation:'spin 0.8s linear infinite' }} /></div>}
        {!loading && posts.length === 0 && (
          <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', gap:10, height:200, color:'var(--muted)' }}>
            <div style={{ fontSize:36 }}>🎬</div>
            <div style={{ fontSize:14 }}>No posts yet — be the first!</div>
            <button onClick={() => setShowUpload(true)} style={{ padding:'8px 20px', borderRadius:30, background:'linear-gradient(135deg, var(--sunset), var(--flame))', color:'white', border:'none', cursor:'pointer', fontSize:13 }}>Create Post</button>
          </div>
        )}
        {posts.map(post => (
          <div key={post.id} style={{ borderRadius:14, overflow:'hidden', background:'var(--card)', border:'1px solid var(--border)' }}>
            <div style={{ height:200, display:'flex', alignItems:'center', justifyContent:'center', background:`linear-gradient(135deg, ${getColor(post.authorName)}, #0f0f1e)`, position:'relative', cursor:'pointer' }}>
              {post.videoURL
                ? <video src={post.videoURL} style={{ width:'100%', height:'100%', objectFit:'cover' }} />
                : <span style={{ fontSize:72 }}>{post.thumbnailEmoji || '🎬'}</span>
              }
            </div>
            <div style={{ padding:'12px 14px' }}>
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:8 }}>
                <div style={{ width:32, height:32, borderRadius:'50%', background:getColor(post.authorName), display:'flex', alignItems:'center', justifyContent:'center', fontSize:12, fontWeight:600, color:'white', flexShrink:0, overflow:'hidden' }}>
                  {post.authorPhoto ? <img src={post.authorPhoto} alt="" style={{ width:'100%', height:'100%', objectFit:'cover' }} /> : initials(post.authorName)}
                </div>
                <div>
                  <div style={{ fontSize:13, fontWeight:500, color:'var(--text)' }}>{post.authorName}</div>
                  <div style={{ fontSize:11, color:'var(--muted)' }}>{timeAgo(post.createdAt)}</div>
                </div>
                {post.country && <span style={{ marginLeft:'auto', fontSize:11, color:'var(--sunset)', padding:'2px 8px', background:'rgba(232,168,56,0.1)', borderRadius:20 }}>📍 {post.country}</span>}
              </div>
              <div style={{ fontSize:13, color:'var(--text)', lineHeight:1.5, marginBottom:8 }}>{post.caption}</div>
              {post.tags?.length > 0 && (
                <div style={{ display:'flex', flexWrap:'wrap', gap:4, marginBottom:10 }}>
                  {post.tags.map(t => <span key={t} style={{ fontSize:11, color:'var(--sunset)', padding:'2px 8px', background:'rgba(232,168,56,0.1)', borderRadius:20 }}>#{t}</span>)}
                </div>
              )}
              <div style={{ display:'flex', gap:4 }}>
                {[['♥', post.likes||0, post.likedBy?.includes(user?.uid)], ['💬', post.comments||0, false], ['↗', 'Share', false]].map(([icon, count, active]) => (
                  <button key={icon} onClick={() => icon==='♥' && likePost(post.id)} style={{ display:'flex', alignItems:'center', gap:4, padding:'6px 12px', borderRadius:30, background:'transparent', border:'1px solid', borderColor: active ? 'var(--flame)' : 'var(--border)', color: active ? 'var(--flame)' : 'var(--muted)', fontSize:12, cursor:'pointer' }}>
                    {icon} {count}
                  </button>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
      {showUpload && <UploadModal onClose={() => setShowUpload(false)} />}
    </div>
  );
}
